import script from "./ShareHolderDropdownFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareHolderDropdownFilter.vue?vue&type=script&setup=true&lang=js"

import "./ShareHolderDropdownFilter.vue?vue&type=style&index=0&id=096d415e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-096d415e"]])

export default __exports__